import { render, staticRenderFns } from "./BiometricsAdmin.vue?vue&type=template&id=02169f43"
import script from "./BiometricsAdmin.vue?vue&type=script&lang=js"
export * from "./BiometricsAdmin.vue?vue&type=script&lang=js"
import style0 from "./BiometricsAdmin.vue?vue&type=style&index=0&id=02169f43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports